<template>
  <div class="kyc-restriction-root">
    <div class="picture">
      <img
        src="../../../shared/assets/images/switch.png"
        alt="icon"
        width="220px"
        height="220px"
      />
    </div>
    <div class="header">{{ $t('KycRestrictionModal | title') }}</div>
    <div class="body rte">
      <div class="body-inner">
        {{ $t('KycRestrictionModal | description') }}
      </div>
    </div>
    <div class="footer">
      <base-button type="cta" :href="`${CONFIG.EMCD_URL}/profile/`" size="lg">
        {{ $t('KycRestrictionModal | action') }}
      </base-button>
    </div>
  </div>
</template>

<script>
import BaseButton from '@/shared/ui/BaseButton/BaseButton.vue'
import { CONFIG } from '@/app/config/config'

export default {
  components: {
    BaseButton,
  },
}
</script>

<style scoped lang="scss">
.kyc-restriction-root {
  display: flex;
  color: var(--text-1);
  line-height: 1.2;
  word-break: break-word;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.picture {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 36px;
  margin-bottom: 50px;
  border-radius: 100%;
}

.header {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
  text-align: center;
  font-weight: 700;
  font-size: 1.725rem; // 28px
  width: 100%;
  line-height: 1;
}

.body {
  font-size: 16px;
  line-height: 24px;
}

.footer {
  width: 100%;
}

.rte {
  line-height: 1.5;
  font-weight: 500;
  color: var(--text-2);
  text-align: center;
  margin-bottom: 40px;
}
</style>
